import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { Methods } from '@/api/v1/cart/delivery-date'
import { isDenebEnabled } from '@/const/flags'
import { aspidaClient } from '@/lib/aspida'
import { queryClient } from '@/lib/react-query'
import { useProxyStore } from '@/providers/proxyStore/ProxyStoreContext'

import { cartKeyFactory } from './key'

export type UpdateCartDeliveryDateDTO = {
  data: Methods['put']['reqBody']
}

type MutationResponse = Awaited<
  ReturnType<typeof aspidaClient.v1.cart.delivery_date.$put>
>

type UseUpdateCartOptions = {
  config?: Omit<
    UseMutationOptions<MutationResponse, AxiosError, UpdateCartDeliveryDateDTO>,
    'onSuccess' | 'mutationFn'
  >
}

export const useUpdateCartDeliveryDate = ({ config }: UseUpdateCartOptions) => {
  const { storeCode } = useProxyStore()

  const mutationFn = ({ data }: UpdateCartDeliveryDateDTO) => {
    if (isDenebEnabled && storeCode) {
      return aspidaClient.v1.employee.proxy_stores
        ._storeCode(storeCode)
        .cart.delivery_date.$put({ body: data })
    }
    return aspidaClient.v1.cart.delivery_date.$put({ body: data })
  }

  return useMutation({
    mutationFn,
    ...config,
    onSuccess: () => queryClient.invalidateQueries(cartKeyFactory.detail()),
  } as UseMutationOptions<MutationResponse, AxiosError, UpdateCartDeliveryDateDTO>)
}
